import * as _ from "underscore";
_.templateSettings.escape = /(?:<%|{{)-([\s\S]+?)(?:%>|}})/g;
_.templateSettings.evaluate = /(?:<%|{{)([\s\S]+?)(?:%>|}})/g;
_.templateSettings.interpolate = /(?:<%|{{)=([\s\S]+?)(?:%>|}})/g;

export { CustomFacet } from './components/CustomFacet';
export { CustomHierarchicalFacet } from './components/CustomHierarchicalFacet';
export { QueryHero } from './components/QueryHero';
export { RecentSearches } from './components/RecentSearches';
export { ResetFacets } from './components/ResetFacets';
export { SearchAssistButton } from './components/SearchAssistButton';
export { SearchAssistFilters } from './components/SearchAssistFilters';
export { SearchAssist } from './components/SearchAssist';
export { SearchError } from './components/SearchError';
export { SearchHelper } from './models/SearchHelper';
export { SelectedFilters } from './components/SelectedFilters';
export { ShowMore } from './components/ShowMore';
export { SimpleSearchbox } from './components/SimpleSearchbox';
export { SuggestionList } from './components/SuggestionList';
export { TotalCount } from './components/TotalCount';
export { TotalCountDetails } from './components/TotalCountDetails';



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components.ts